import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import Screen from 'src/Libs/installation-statement/components/Modals/ModalState/Screen'
import { getThemedBlankViewImage } from 'src/Libs/utils'
import { BlankViewImageVariants } from 'src/Components/blank-view'

const SaveGenerating: React.FC = () => {
  const { t } = useCustomTranslation()
  const blankViewImageNeutral = getThemedBlankViewImage(BlankViewImageVariants.Neutral)

  return (
    <Screen
      title={t('installation-statement.modal-state.save-generating.title')}
      body={t('installation-statement.modal-state.save-generating.body')}
      imageSource={blankViewImageNeutral}
    />
  )
}

export default SaveGenerating
